module.exports = __webpack_public_path__ + "img/Vendors.6cc6b720.svg";